<template>
    <section :id="slice.primary.anchorName || undefined" class="slice slice-skills">
        <div class="slice-content">
            <PrismicRichText :field="slice.primary.title" class="slice-title" />
            <div class="slice-body">
                <div v-for="(skill, i) in slice.items" :key="i" class="skill">
                    <MktMaltPrismicImage :image-field="skill.image" class="skill-image" />
                    <div class="skill-content">
                        <div class="skill-title">{{ skill.title }}</div>
                        <PrismicRichText :field="skill.text" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import type {SkillsSlice} from '@prismicio-types';
    import {MktMaltPrismicImage} from '#components';

    defineProps(getSliceComponentProps<SkillsSlice>(['slice', 'index', 'slices', 'context']));
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .slice-skills {
        .slice-body {
            display: flex;
            flex-wrap: wrap;
            text-align: left;
        }

        .skill {
            display: flex;
            align-items: flex-start;
            margin-bottom: var(--joy-core-spacing-8);
            gap: var(--joy-core-spacing-4);

            @include mq.screen_md(min) {
                width: 50%;
                gap: var(--joy-core-spacing-5);

                &:nth-child(odd) {
                    padding-right: var(--joy-core-spacing-8);
                }
            }

            &-image {
                flex: none;
                width: 64px;

                @include mq.screen_md(min) {
                    width: 96px;
                }
            }

            &-content {
                flex: 1 1 0%;
            }

            &-title {
                font-family: var(--joy-font-family-title);
                font-size: var(--joy-font-size-primary-600);
                color: var(--joy-color-neutral-60);
                margin-bottom: var(--joy-core-spacing-2);

                @include mq.screen_md(min) {
                    font-size: var(--joy-font-size-secondary-200);
                }
            }
        }
    }
</style>
